/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ScopeType {
    ORGANIZATION = 'organization',
    DIVISION = 'division',
}
